import React, { useState, useContext } from 'react';
import ExlNavMenu from '../components/exl/ExlNavMenu';
import { DataContext } from '../store';
import ErrorPage from './error';

const ExlPage = ({ children, pageName }) => {
    const {
        store: { user },
    } = useContext(DataContext);

    const [error] = useState(null);
    const content =
        //change this following line to change who sees the exl part
        (error || !user || !(user.isExlAdmin || user.isAdmin || user.isExlUser)) ? (
            <ErrorPage error={error} />
        ) : (
            <section>
                <ExlNavMenu type={pageName} />
                {children}
            </section>
        );
    return content;
};

export default ExlPage;
